import React from 'react';
import { styled } from 'theme';
import { Box, CircularProgress } from '@mui/material';
import Typography from '@mui/material/Typography';

interface PropsAnimation {
  text?: string;
  small?: boolean;
}

const LoadingAnimation = ({ text }: PropsAnimation) => (
    <Box
        sx={{
            display: 'flex',
            alignItems: 'center',
        }}
    >
        <Box
            sx={{
                flexGrow: 1,
            }}
        />
        <Box>
            <CircularProgress />
        </Box>
        <Box
            sx={{
                ml: 3,
            }}
        >
            <Typography variant={'h5'}>{text}</Typography>
        </Box>
        <Box
            sx={{
                flexGrow: 1,
            }}
        />
    </Box>
);

const Loading = styled(LoadingAnimation)<PropsAnimation>(() => ({
    textAlign: 'center',
    padding: '30px 0',
}));

export default Loading;
